import fuzzysort from 'fuzzysort';

export const fuzzySearch = <Item,>(
    searchText: string,
    objectAndKeys: { obj: Item; key: string }[],
): Item[] => {
    return fuzzysort.go(searchText, objectAndKeys, { key: 'key' }).map((hit) => hit.obj.obj);
};
